import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "\n      d-flex\n      flex-column flex-column-fluid\n      bgi-position-y-bottom\n      position-x-center\n      bgi-no-repeat bgi-size-contain bgi-attachment-fixed\n    ",
  style: {"background-image":"url('media/illustrations/sketchy-1/14.png')"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "mb-12"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/logo.png",
    class: "h-45px"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_view)
    ])
  ]))
}